<template>
  <div>
    <v-card class="mx-auto pa-6 mt-6" max-width="500">
      <v-card-subtitle>{{ $t("addressComplete.description") }}</v-card-subtitle>
      <v-card-text>
        <v-text-field
          id="eudopcasearch"
          ref="eudopcasearch"
          label="Chercher"
          v-model="address.line1"
          :disabled="disabled"
          :loading="loading"
          outlined
          dense
        ></v-text-field>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { eSpecif } from "@/utils/eSpecif"
import { updateAddress, loadAddress } from "@/plugins/services/addressComplete"
export default {
  data() {
    return {
      context: "",
      disabled: false,
      loading: false,
      mode: 0,
      tab: 0,
      fileId: 0,
      address: {
        line1: "",
        line2: "",
        city: "",
        postalCode: "",
        provinceCode: "",
        countryIso2: ""
      }
    }
  },
  created() {
    try {
      this.mode = this.$route.query.mode
      if (sessionStorage.getItem("eudonetparams") !== null) {
        let eudonetparams = JSON.parse(sessionStorage.getItem("eudonetparams"))
        this.context = eudonetparams.t
        sessionStorage.removeItem("eudonetparams")
      } else {
        this.closeModal(false)
      }
    } catch (e) {
      if (process.env.VUE_APP_DEBUG) {
        console.log(e)
      }
    }
  },
  mounted() {
    this.setup()
  },

  methods: {
    setup() {
      let fields = [{ element: "eudopcasearch", field: "chercher", mode: window.pca.fieldMode.SEARCH }]
      let options = {
        key: process.env.VUE_APP_ADDRESSCOMPLETE_KEY,
        autoSearch: true
      }
      let control = new window.pca.Address(fields, options)
      control.listen("populate", (address) => {
        this.loading = true
        this.disabled = true
        updateAddress({ token: this.context, mode: this.mode, address: address }).then(() => {
          this.closeModal(true)
        })
      })

      loadAddress({ token: this.context, mode: this.mode }).then((res) => {
        this.tab = res.data.tab
        this.fileId = res.data.fileId
        this.address = res.data.address
        this.setFocusOnSearch()
      })
    },
    setFocusOnSearch() {
      this.$nextTick(() => {
        this.$refs.eudopcasearch.focus()
      })
    },
    closeModal(withRefresh) {
      let spe = new eSpecif(1)
      if (withRefresh === true) {
        spe.LoadFile(this.tab, this.fileId)
      }
      setTimeout(() => {
        spe.CloseModalSpecif()
      }, 500)
    }
  }
}
</script>

<style scoped>
</style>
